<template>
  <div class="app">
    <nav-bar/>
    <section class="section">
      <div class="container">
        <router-view/>
      </div>
    </section>
  </div>
</template>

<script>
import NavBar from "./app/NavBar";

export default {
  name: 'Threadis',
  components: {
    NavBar,
  }
}
</script>

<style scoped>
section.section {
  padding: 1em 0;
}
</style>
